import {normalizeBaseCustomFrame,type BaseCustomFrameSettings} from '@motionpitch/template-contract';
export {normalizeBaseCustomFrame,DEFAULT_BASE_CUSTOM_FRAME,type BaseCustomFrameSettings} from '@motionpitch/template-contract';

export function getBaseFrameSourceSize(source: CanvasImageSource | null): { width:number; height:number } {
  const s=source as any;
  const width=Number(s?.videoWidth || s?.naturalWidth || s?.displayWidth || s?.width || 1600);
  const height=Number(s?.videoHeight || s?.naturalHeight || s?.displayHeight || s?.height || 1000);
  return {width:Number.isFinite(width)&&width>0?width:1600,height:Number.isFinite(height)&&height>0?height:1000};
}

export interface BaseFrameRect { x:number; y:number; width:number; height:number; radius:number }
export interface BaseFrameLayout { inner:BaseFrameRect; outer:BaseFrameRect; border:number }

export function getBaseFrameLayout(aspect:number,size:number,input?:Partial<BaseCustomFrameSettings>):BaseFrameLayout {
  const settings=normalizeBaseCustomFrame(input), scale=settings.scale/100;
  const safeAspect=Number.isFinite(aspect)&&aspect>0?aspect:1.6;
  const longSide=size*.78*scale;
  const width=safeAspect>=1?longSide:longSide*safeAspect;
  const height=safeAspect>=1?longSide/safeAspect:longSide;
  const border=settings.thickness/1920*size*scale;
  const radius=Math.min(width/2,height/2,settings.radius/1920*size*scale);
  const x=size*(.5+settings.x/100)-width/2,y=size*(.5+settings.y/100)-height/2;
  return {inner:{x,y,width,height,radius},outer:{x:x-border,y:y-border,width:width+border*2,height:height+border*2,radius:radius+border},border};
}
